import React from "react";
import { memo } from "react";
import styles from "./TireRacksPanel.module.scss";
import Stack from "@mui/material/Stack";
import { useStoreSystem } from "../../../../store";
import shallow from "zustand/shallow";
import DefaultIcon from "../../../../assets/icons/default_icon.jpg";

export const TireRacksPanel = () => {
    const { setTireRacksModal, constructions } = useStoreSystem(
        (state) => ({
            setTireRacksModal: state.setTireRacksModal,
            constructions: state.constructions,
        }),
        shallow
    );

    return (
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-around">
            {Object.entries(constructions).map(([category, catalog]) => {
                return (
                    <button
                        key={catalog.NAME}
                        onClick={() => {
                            setTireRacksModal(true, category);
                        }}
                        className={styles.decorCategory}
                    >
                        <img src={catalog.IMG || DefaultIcon} alt={catalog.NAME} />
                        <span>{catalog.NAME}</span>
                    </button>
                );
            })}
        </Stack>
    );
};
